import React, { useEffect } from "react";
import { Tooltip } from "bootstrap";
import PropTypes from "prop-types";
import $ from "jquery"; // for Bootstrap tooltips

const MyQuote = ({ quotes }) => {
useEffect(() => {
    document.title = "My Quote | Workgear365";
  }, []);
  useEffect(() => {
    // Initialize all tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach((el) => {
      new Tooltip(el);
    });
  }, []);

  // Helper to normalize items
  const getItems = (items) => {
    return Array.isArray(items[0]) ? items[0] : items;
  };

  if (!quotes || quotes.length === 0) {
    return (
      <div className="text-center py-5">
        <div className="mb-4">
          <i className="fa-solid fa-quote-left fa-4x text-muted"></i>
        </div>
        <h3 className="text-muted mb-3">No Quote Requests Yet</h3>
        <p className="text-muted mb-4">
          You haven't submitted any quote requests yet. Start by browsing products and adding items to your quote cart.
        </p>
        <div className="d-flex gap-3 justify-content-center">
          <a href="/" className="btn btn-primary btn-lg">
            <i className="fa-solid fa-shopping-cart me-2"></i>Browse Products
          </a>
          <a href="/quotes" className="btn btn-outline-primary btn-lg">
            <i className="fa-solid fa-info-circle me-2"></i>Learn About Quotes
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-5">
      <div className="row mb-4">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h1 className="text-primary fw-bold">
            <i className="fa-solid fa-history me-2"></i>My Quote Requests
          </h1>
          <a href="/quotes" className="btn btn-primary">
            <i className="fa-solid fa-plus me-2"></i>New Quote Request
          </a>
        </div>
      </div>

      <div className="row">
        {quotes.map((quote) => {
          const normalizedItems = getItems(quote.items);
          return (
            <div key={quote.id} className="col-md-6 col-lg-4 mb-4">
              <div className="card border-0 shadow-sm h-100 quote-card">
                <div className={`card-header text-white bg-${quote.status === 'new' ? 'primary' : quote.status === 'in_progress' ? 'warning' : 'success'}`}>
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="mb-0">Quote #{quote.id}</h6>
                    <span className="badge bg-light text-dark">
                      {quote.status.replace('_', ' ').toUpperCase()}
                    </span>
                  </div>
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <small className="text-muted">
                      <i className="fa-solid fa-calendar me-1"></i>
                      {new Date(quote.created_at).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" })}
                    </small>
                  </div>

                  {/* Stats Card */}
                  <div className="mb-3">
                    <div className="row text-center">
                      <div className="col-6">
                        <div className="border-end">
                          <h5 className="text-primary mb-1">{normalizedItems.length}</h5>
                          <small className="text-muted">Items</small>
                        </div>
                      </div>
                      <div className="col-6">
                        <h5 className={`mb-1 text-${quote.only_quote !== 0 ? "success" : "muted"}`}>
                          <i className="fa-solid fa-check"></i>
                        </h5>
                        <small className="text-muted">
                          {quote.only_quote === 0 ? "Imprinting" : "Bulk Quote Only"}
                        </small>
                      </div>
                    </div>
                  </div>

                  {/* Items Preview */}
                  <div className="mb-3">
                    <h6 className="fw-bold mb-2">Items Requested:</h6>
                    <div className="small">
                      {normalizedItems.slice(0, 2).map((item, index) => (
                        <div key={index} className="d-flex align-items-center mb-1">
                          {item.product_image ? (
                            <img
                              src={item.product_image}
                              alt={item.product_name}
                              className="me-2 rounded"
                              style={{ width: '30px', height: '30px', objectFit: 'cover' }}
                            />
                          ) : (
                            <div className="me-2 bg-light rounded d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px' }}>
                              <i className="fa-solid fa-image text-muted"></i>
                            </div>
                          )}
                          <div className="flex-grow-1">
                            <div className="text-truncate">{item.product_name}</div>
                            <small className="text-muted">Qty: {item.quantity}</small>
                          </div>
                        </div>
                      ))}
                      {normalizedItems.length > 2 && (
                        <small className="text-muted">
                          <i className="fa-solid fa-ellipsis-h me-1"></i>
                          and {normalizedItems.length - 2} more items
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Status Information */}
                  <div className="mb-3">
                    {quote.status === 'New Quote' ? (
                      <div className="alert alert-info py-2 mb-0">
                        <small><i className="fa-solid fa-clock me-1"></i>Awaiting review - We'll respond within 24 hours</small>
                      </div>
                    ) : quote.status === 'Quote Sent' ? (
                      <div className="alert alert-warning py-2 mb-0">
                        <small><i className="fa-solid fa-cog me-1"></i>Quote is sent to you</small>
                      </div>
                    ) : (
                      <div className="alert alert-success py-2 mb-0">
                        <small><i className="fa-solid fa-check me-1"></i>Quote completed - Check your email for details</small>
                      </div>
                    )}
                  </div>
                </div>

                <div className="card-footer bg-light d-flex justify-content-between align-items-center">
                  <small className="text-muted">Last updated: {new Date(quote.updated_at).toLocaleString()}</small>
                  <div>
                    {quote.additional_notes && (
                      <button className="btn btn-sm btn-outline-info" data-bs-toggle="tooltip" title="Has additional notes">
                        <i className="fa-solid fa-sticky-note"></i>
                      </button>
                    )}
                    {(quote.design_image || quote.lettering_file || quote.logo_file) && (
                      <button className="btn btn-sm btn-outline-warning" data-bs-toggle="tooltip" title="Has file attachments">
                        <i className="fa-solid fa-paperclip"></i>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

MyQuote.propTypes = {
  quotes: PropTypes.array.isRequired
};

export default MyQuote;
